import theme from '../../base';

const text = {
  foreground: theme.colors.neutrals.gray200,
};

export default text;
